import { types, getEnv, Instance } from 'mobx-state-tree';
import { gameGroupStore } from './gameGroup';
//import { createComparerOfSorting, SortType } from 'easit--utils';
import { IAppEnv } from '../appEnvironment';
import { EventTvModel } from './eventTv';
import { IMatchStatsInfo, rootCategoryId, StatisticsInApiStore, OddsPopularityStatsInApiStore } from 'eTip--common';

export const EventDataStore = types
    .model({
        Id: types.number,
        remainingSeconds: types.maybeNull(types.number),
        CategoryPath: types.maybeNull(types.string),
        GameGroups: types.optional(types.array(gameGroupStore), []),
        Date: types.maybeNull(types.Date),
        ShowDayOfDate: types.maybeNull(types.boolean),
        DetailsCount: types.optional(types.number, 0),
        GraphicsPresentationID: types.maybeNull(types.number),
        CategoryId: types.optional(types.string, rootCategoryId),
        Name: types.string,
        EventTvs: types.maybeNull(types.array(EventTvModel)),
        Statistics: types.maybeNull(StatisticsInApiStore),
        Info: types.maybeNull(types.string),
        MarketingMessage: types.maybeNull(types.string),
        SuperOddsPopularityStats: types.maybeNull(types.array(OddsPopularityStatsInApiStore)),
    })
    .views(self => {
        const env = getEnv<IAppEnv>(self);
        return {
            get key() {
                return `${self.Id}c${self.CategoryId}`
            },
            idByDetails: (detailId: number) => {
                return `${self.Id}_${detailId}`;
            },
            isSelected: (routeKey: string) => {
                if (!routeKey) return false;
                let split = routeKey.split('c');
                return Number(split[0]) === self.Id;
            },
            get otherDetailsCount() {
                return self.DetailsCount - 1;
            },
            get showLoginTooltip() {
                return env.loggedUserId <= 0;
            },
            get remainingTime(): string {
                if (self.remainingSeconds != null) {
                    if (self.remainingSeconds > 0) {
                        const hours = Math.floor(self.remainingSeconds / 3600);
                        const minutes = Math.floor((self.remainingSeconds - hours * 3600) / 60);
                        const seconds = Math.floor(self.remainingSeconds - (hours * 3600 + minutes * 60));
                        return `-${hours < 10 ? '0' + hours : hours}:${minutes < 10 ? '0' + minutes : minutes}:${seconds < 10 ? '0' + seconds : seconds}`;
                    } else {
                        return '00:00:00';
                    }
                } else {
                    return null;
                }
            },
            get statsInfo() {
                if (self.Statistics) {
                    return <IMatchStatsInfo>{
                        onStatisticsAction: env.eventStats.viewStatistics,
                        statistics: self.Statistics
                    };
                }
                return null;
            }
        };
    })
    .actions(self => {
        const env = getEnv<IAppEnv>(self);

        const countDown = (isInit: boolean) => {
            if ((!isInit && self.remainingSeconds == null) || !self.Date) {
                return;
            }
            var msec = self.Date.getTime() - env.dateTimeService.now().getTime();
            if (msec !== 0) {
                self.remainingSeconds = msec / 1000;
            } else {
                self.remainingSeconds = 0;
            }
        };

        return {
            countDown
        };
    });

export type IEventDataStore = Instance<typeof EventDataStore>;